import React from 'react';
import { ResponsiveContainer, FunnelChart as RechartsFunnelChart, Funnel, Tooltip, LabelList, Cell } from 'recharts';
import { FunnelStageData } from '../utils/mockData';
interface FunnelChartProps {
  data: FunnelStageData[];
}
const CustomTooltip = ({
  active,
  payload
}: any) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return <div className="bg-white p-3 border border-slate-200 shadow-lg rounded-lg" data-id="element-31">
        <p className="font-semibold text-slate-900" data-id="element-32">{data.name}</p>
        <p className="text-slate-600" data-id="element-33">
          Volume:{' '}
          <span className="font-medium text-slate-900" data-id="element-34">{data.value}</span>
        </p>
        <p className="text-emerald-600 text-sm" data-id="element-35">
          Conversion: {data.conversionRate}
        </p>
      </div>;
  }
  return null;
};
export function FunnelChart({
  data
}: FunnelChartProps) {
  return <div className="w-full h-[400px] bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-36">
      <h3 className="text-lg font-semibold text-slate-900 mb-6" data-id="element-37">
        Pipeline Visualization
      </h3>
      <ResponsiveContainer width="100%" height="100%" data-id="element-38">
        <RechartsFunnelChart data-id="element-39">
          <Tooltip content={<CustomTooltip data-id="element-41" />} data-id="element-40" />
          <Funnel dataKey="value" data={data} isAnimationActive data-id="element-42">
            <LabelList position="right" fill="#000" stroke="none" dataKey="name" data-id="element-43" />
            {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-44" />)}
          </Funnel>
        </RechartsFunnelChart>
      </ResponsiveContainer>
    </div>;
}